import {
    IComponentController,
    IComponentOptions,
    IOnChangesObject,
} from 'angular';
import {
    IFontStyleModel,
    IVFInfo,
    IVFInstance,
    VariableInfo,
    VariationSettings,
    VFCustomAxes,
} from '../../../classes';
import { getFontName } from '../../../functions';
import { getCssFontVariationSettings } from '../../../functions/getCssFontVariationSettings';
import template from './variable-specimen.html';

export class VariableSpecimenComponent implements IComponentController {
    static $inject = [];

    // #region bindings
    // do not modify bindings, if you need to manipulate a bound value for local use, create an _prefixed local copy.
    font?: IFontStyleModel;
    text?: string;
    size?: number;
    label?: string;
    specimenLinkTo: 'family' | 'style' | 'none' = 'none';
    onVariationSettingsChanged?: (args: {
        variationSettings: VariationSettings;
    }) => void;

    // buy button settings
    showBuyButton?: boolean;

    // save button settings
    showSaveButton?: boolean;

    // #endregion

    // #region locals
    info = new VariableInfo({ instances: [], order: [], axes: {} });
    cssFontFamily = '"Adobe Blank"';
    cssFontSize = '56px';
    cssVariationSettings = '';
    // #endregion

    // #region state
    selectedInstance?: IVFInstance;
    variationSettings: VariationSettings = {};
    instanceIdx: Record<string, IVFInstance> = {};
    // #endregion

    $onChanges(changes: IOnChangesObject): void {
        // console.log('VariableSpecimenComponent.$onChanges', changes);
        if (changes.font) {
            const font = changes.font.currentValue as IFontStyleModel;
            const variable_info: IVFInfo = font.variable_info;
            if (!variable_info) return;
            this.info = new VariableInfo(variable_info);
            this.cssFontFamily = `"${getFontName(font)}", "Adobe Blank"`;
        }
        if (changes.size) {
            this.cssFontSize = this.size ? `${this.size}px` : '56px';
        }
    }

    updateAxis(axis: VFCustomAxes, value?: number): void {
        // console.log('VariableSpecimenComponent.updateAxis', axis, value);
        if (value == undefined || value == null) {
            // unset axis if value is not set.
            delete this.variationSettings[axis];
            return;
        }
        this.variationSettings = Object.assign({}, this.variationSettings, {
            [axis]: value,
        });
        this.cssVariationSettings = getCssFontVariationSettings(
            this.variationSettings
        );
        this.selectedInstance = this.info.getInstanceByAxes(
            this.variationSettings
        );
        this.onVariationSettingsChanged &&
            this.onVariationSettingsChanged({
                variationSettings: this.variationSettings,
            });
    }

    selectInstance(instance: IVFInstance): void {
        // console.log('VariableSpecimenComponent.selectInstance', instance);
        this.selectedInstance = instance;
        if (instance) this.variationSettings = Object.assign({}, instance.axes);
    }
}

export const VariableSpecimenComponentOptions: IComponentOptions = {
    controller: VariableSpecimenComponent,
    bindings: {
        font: '<',
        scale: '<',
        size: '<?',
        label: '<?',
        labelOnly: '<?',
        customText: '<?',
        onVariationSettingsChanged: '&?',
        specimenLinkTo: '@',

        // buy button
        showBuyButton: '<',

        // save button
        showSaveButton: '<',
    },
    template,
};
